import type { ReactNode } from "react";
import { useQuoteCopy } from "../i18n/QuoteCopyContext";
import { ArrowLeftIcon, ArrowRightIcon } from "./icons";

interface Props {
  onBack: () => void;
  onContinue: () => void;
  backLabel?: ReactNode;
  continueLabel?: ReactNode;
  continueDisabled?: boolean;
  showContinue?: boolean;
}

export function WizardNav({
  onBack,
  onContinue,
  backLabel,
  continueLabel,
  continueDisabled = false,
  showContinue = true,
}: Props) {
  const copy = useQuoteCopy();
  return (
    <div className="nv-wizard-nav">
      <button type="button" className="btn-secondary nv-wizard-back" onClick={onBack}>
        <ArrowLeftIcon size={16} />
        {backLabel ?? copy.t("nav.back")}
      </button>
      {showContinue && (
        <button
          type="button"
          className="btn-submit"
          disabled={continueDisabled}
          onClick={onContinue}
        >
          {continueLabel ?? (
            <>
              {copy.t("nav.continue")}
              <ArrowRightIcon size={16} />
            </>
          )}
        </button>
      )}
    </div>
  );
}
